import {useMutation} from "@tanstack/react-query";
import {updatePassword} from "../services/account/account.service";
import {useChangePassword} from "../store/useAccountScreens.store";

const useUpdatePassword = () => {
  const changePassword = useChangePassword(state => state.changePassword);
  const {
    data,
    isError,
    isPending,
    error,
    mutate: postUpdate,
    isSuccess,
  } = useMutation({
    mutationKey: ["update-password"],
    mutationFn: updatePassword,
    onSuccess: ({data}) => {
      changePassword(data);
    },
    onError: _error => {},
  });

  return {
    postUpdate,
    data,
    isError,
    isPending,
    isSuccess,
    error,
  };
};

export default useUpdatePassword;
